import { motion } from "motion/react";
import { Search, MapPin, Edit, UserCheck } from "lucide-react";

const features = [
  {
    icon: Search,
    title: "決済方法で検索",
    description: "PayPay、交通系IC、クレジットカードなど、決済アイコンで絞り込み。お客さまがお店を見つけやすくなります。",
    gradient: "from-purple-500 to-pink-500",
  },
  {
    icon: MapPin,
    title: "地図で見つかる",
    description: "現在地周辺の対応店舗を表示し、来店前の決済方法確認をスムーズに。",
    gradient: "from-blue-500 to-cyan-500",
  },
  {
    icon: Edit,
    title: "簡単ダッシュボード",
    description: "決済の追加・変更、店舗情報の編集、掲載店舗の削除がワンクリック。",
    gradient: "from-green-500 to-emerald-500",
  },
  {
    icon: UserCheck,
    title: "オーナー申請",
    description: "店舗情報を入力して即掲載。新規登録も1分で完了。",
    gradient: "from-red-500 to-pink-500",
  },
];

export function Features() {
  return (
    <section id="features" className="py-24 bg-background relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-600/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="px-4 py-2 rounded-full bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-600/30 text-purple-600">
            機能
          </span>
          <h2 className="mt-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
            対応する決済方法で店舗を探せるキャッシュレス決済マップ
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-muted-foreground">
            決済方法から、あなたのお店を見つけてもらいやすく。月300円のみの明快な料金で、キャッシュレス対応を宣伝できます。
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative bg-card border border-border rounded-2xl p-8"
            >
              
              <div className="relative">
                <div className={`inline-flex p-3 rounded-xl bg-gradient-to-r ${feature.gradient} mb-4`}>
                  <feature.icon className="text-white" size={24} />
                </div>
                
                <h3 className="mb-3">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
